import { createEmptyAction, createMapAction } from "chalet-shared";

export const actionCreators = {
    onNotificationClosed: createMapAction(
        "ON_NOTIFICATION_CLOSED",
        (x: { roomId: string; ts: number }) => x
    ),
    onNotificationClicked: createMapAction("ON_NOTIFICATION_CLICKED", (roomId: string) => roomId),
    setNotificationPermission: createMapAction(
        "SET_NOTIFICATION_PERMISSION",
        (x: NotificationPermission | undefined) => x
    ),
    notificationSoundFailed: createEmptyAction("NOTIFICATION_SOUND_FAILED"),
};
